import { mixinBaseComputed } from "./base";
import { mixinRemoveHttp } from "./removeHttp";
import { mixinOpenUrl } from "./openUrl";
import { mixinOpenVip } from "./openVip";
export function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$use = _ref.use,
      use = _ref$use === void 0 ? true : _ref$use,
      _ref$baseMixinPrefix = _ref.baseMixinPrefix,
      baseMixinPrefix = _ref$baseMixinPrefix === void 0 ? '' : _ref$baseMixinPrefix,
      _ref$removeHttp = _ref.removeHttp,
      removeHttp = _ref$removeHttp === void 0 ? true : _ref$removeHttp,
      _ref$openUrl = _ref.openUrl,
      openUrl = _ref$openUrl === void 0 ? true : _ref$openUrl,
      _ref$openVip = _ref.openVip,
      openVip = _ref$openVip === void 0 ? true : _ref$openVip;

  if (!use) return;
  mixinBaseComputed(baseMixinPrefix);

  if (removeHttp) {
    mixinRemoveHttp();
  }

  if (openUrl) {
    mixinOpenUrl();
  }

  if (openVip) {
    mixinOpenVip();
  }
}